import { ShoppingCartItem, Money, Address, TicketItem, OrderMessage } from "../models"

export class Order {
	uuid: string
	secureOrderId: string
	principalId: string
	merchantId: string
	paymentType: string
	shipmentType: string
	customerUUID: string
	customerRef: string
	customerFullName: string
	totalOrderPrice: Money
	orderPlacedAt: string
	orderState: string
	billingAddress: Address
	shippingAddress: Address
	ticketItems: TicketItem[]
	orderMessages: OrderMessage[]
}




// WEBPACK FOOTER //
// ./src/app/models/order.model.ts